import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import 'react-app-polyfill/stable'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import 'reflect-metadata'
import { createGlobalStyle } from 'styled-components'
import App from './containers/AppContainer'
import createStore from './reducers/store'
import serviceWorker from './service-worker/service-worker'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    user-select: none;
  }

  body {
    margin: 0;
    padding: 0;
  }

  @media screen and (max-width: 319px) {
    html {
      font-size: 1.45vw;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 439px) {
    html {
      font-size: 1.1vw;
    }
  }

   @media screen and (min-width: 440px) and (max-width: 575px) {
    html {
      font-size: 0.9vw;
    }
  }

  @media screen and (orientation: landscape) and (min-width: 576px) and (max-width: 767px) {
    html {
      font-size: 0.85vw;
    }
  }

  @media screen and (orientation: portrait) and (min-width: 576px) and (max-width: 767px) {
    html {
      font-size: 1.12vw;
    }
  }

  @media screen and (orientation: landscape) and (min-width: 768px) and (max-width: 991px) {
    html {
      font-size: 0.7vw;
    }
  }

  @media screen and (orientation: portrait) and (min-width: 768px) and (max-width: 991px) {
    html {
      font-size: 1.12vw;
    }
  }

  @media screen and (orientation: landscape) and (min-width: 992px) {
    html {
      font-size: 0.6vw;
    }
  }

  @media screen and (orientation: portrait) and (min-width: 992px) {
    html {
      font-size: 1vw;
    }
  }
`

const store = createStore()

render(
  <Provider store={store}>
    <GlobalStyle/>
    <App/>
  </Provider>,
  document.getElementById('root') as HTMLElement,
)

serviceWorker.register('service-worker.js')
